module.exports = "/_next/static/images/c834cf612220c70984cc3ca1dbe806c9-four-cards.svg";